import React, { lazy, Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'
import App from '../../app/App'
import SolidsportRedirect from './SolidsportRedirect'
import { HandleUtmSource } from './HandleUtmSource'
import { RATE_LIMIT_PAGE_PATH, useRateLimitContext } from 'pages/rateLimitPage'
import { Loader } from 'components/Loader/Loader'

const RateLimitPage = lazy(() => import('pages/rateLimitPage'))

const paths = [
  '/calendar',
  '/comingsoon',
  '/livestreams',
  '/landing',
  '/broadcast',
  '/browse',
  '/search',
  '/login',
  '/profile',
  '/access_invite',
  '/user',
  '/404',
  '/:company?'
]

export const BaseRoutes = () => {
  HandleUtmSource()
  useRateLimitContext()

  return (
    <Switch>
      <Route exact path={['/']}>
        <SolidsportRedirect />
      </Route>
      <Route exact path={RATE_LIMIT_PAGE_PATH}>
        <Suspense fallback={<Loader />}>
          <RateLimitPage />
        </Suspense>
      </Route>
      <Route path={paths}>
        <App />
      </Route>
    </Switch>
  )
}
